import orderBy from 'lodash/orderBy';
import fill from 'lodash/fill';

const sortAscToDesc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

const sortDescToAsc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};

const customSort = (list = [], iteratees, sortDirection) => {
  const sortArray = fill(Array(iteratees ? iteratees.length : 1), sortDirection);
  const orderedList = orderBy(list, iteratees, sortArray);
  return orderedList;
};

export {
  sortAscToDesc,
  sortDescToAsc,
  customSort
};
